import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { store } from './redux/store.ts';
import { Provider } from 'react-redux';
import 'semantic-ui-css/semantic.min.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
